import { urlApiDocument } from '~/utils/constants/apis';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import {
  IDocument,
  IDocumentByFolderParams,
  IEditDocumentParams,
  IUploadDocumentParams,
} from '~/utils/interface/document';
import axiosClient from './axiosClient';
import { CONTENT_TYPE_FORM_DATA } from '~/utils/constants/common';

const documentApi = {
  uploadDocument: async (payload: IUploadDocumentParams) => {
    const { folderId, formData } = payload;
    const url = urlApiDocument.uploadDocument(folderId);
    return axiosClient.post<IBaseResponse>(url, formData, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  getDocumentByFolder: ({ folderId, params }: IDocumentByFolderParams) => {
    const url = urlApiDocument.getDocumentList(folderId);
    return axiosClient.get<IBaseResponse<IListDataResponse<IDocument[]>>>(url, { params });
  },

  editDocument: (payload: IEditDocumentParams) => {
    const { fileId, formData } = payload;
    const url = urlApiDocument.editDocument(fileId);
    return axiosClient.put<IBaseResponse>(url, formData, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  deleteDocument: (fileId: string) => {
    const url = urlApiDocument.deleteDocument(fileId);
    return axiosClient.delete<IBaseResponse>(url);
  },
};

export default documentApi;
